import { Injectable, ApplicationRef, ElementRef } from '@angular/core';
import { NgElement, WithProperties } from '@angular/elements';
import { URLService } from '@core/services/url.service';
import { ReqService } from './req.service';

interface IPropHeader {
  product: string;
  country: string;
  locale: string;
  site: string;
  redirect: string;
}
@Injectable()
export class InjectHeaderAndFooterWCService {
  private appRootRef: ElementRef;
  private headerWC = document.createElement('am-header-wc') as NgElement &
    WithProperties<IPropHeader>;
  private footerWC = document.createElement('am-footer-wc') as NgElement &
    WithProperties<{ country: string }>;

  constructor(
    private reqService: ReqService,
    public urlService: URLService,
    public applicationRef: ApplicationRef,
  ) {
    const appRootElement = this.applicationRef.components[0];
    this.appRootRef =
      appRootElement &&
      appRootElement.injector &&
      appRootElement.injector.get(ElementRef);
  }

  showWC() {
    this.headerWC.setAttribute('country', this.reqService.getCountry());
    this.headerWC.setAttribute('locale', this.reqService.getLocale());
    this.headerWC.setAttribute('site', this.reqService.getSite());

    this.footerWC.setAttribute('country', this.reqService.getCountry());

    this.appRootRef.nativeElement.children[0].insertAdjacentElement(
      'beforeend',
      this.headerWC,
    );
    this.appRootRef.nativeElement.insertAdjacentElement('beforeend', this.footerWC);

    this.urlService.currentTab().subscribe((tab) => {
      this.headerWC.setAttribute('product', tab);
    });
  }
}
